import { Pipe, PipeTransform } from '@angular/core';
import { TranslocoService } from '@ngneat/transloco';
import * as moment from 'moment';

@Pipe({
  name: 'momentDiff'
})
export class MomentDiffPipe implements PipeTransform {
  constructor(private translocoService: TranslocoService) {}
  transform(time: string, curTime: moment.Moment): string {
    let diffDays = 0;
    let diffHours = 0;
    let diffMins = 0;
    let diffYear = 0;
    let diffMonth = 0;
    let diff = moment(time).diff(curTime, 'minutes');
    let diffDay = moment(time).diff(curTime, 'days');
    const prefix = diff > 0 ? '' : '-';
    diff = Math.abs(diff);
    diffDay = Math.abs(diffDay);

    if (diffDay / 365 >= 1) {
      diffYear = Math.floor(diffDay / 365);
    } else if (diffDay / 30 >= 1) {
      diffMonth = Math.floor(diffDay / 30);
    } else if (diff <= 60) {
      diffMins = diff;
    } else if (diff <= 24 * 60) {
      diffHours = (diff - (diff % 60)) / 60;
      diffMins = diff - diffHours*60;
    } else {
      diffDays = (diff - (diff % (24 * 60))) / (24 * 60);
      const _diff = diff - diffDays * 24 * 60;
      diffHours = (_diff - (_diff % 60)) / 60;
      diffMins = _diff - diffHours*60;
    }

    if (diffYear !== 0) {
      return `${prefix}${diffYear} ${this.translocoService.translate('common.lowerYears')}`
    } else if (diffMonth !== 0) {
      return `${prefix}${diffMonth} ${this.translocoService.translate('common.lowerMonths')}`
    } else if (diffDays !== 0) {
      return `${prefix}${diffDays} ${this.translocoService.translate('common.day_lower')}, ${diffHours} ${this.translocoService.translate('common.hour_lower')}, ${diffMins} ${this.translocoService.translate('common.minute_lower')}`;
    } else if (diffHours !== 0) {
      return `${prefix}${diffHours} ${this.translocoService.translate('common.hour_lower')}, ${diffMins} ${this.translocoService.translate('common.minute_lower')}`;
    } else {
      return `${prefix}${diffMins} ${this.translocoService.translate('common.minute_lower')}`;
    }
  }
}
